$(document).ready(() => {
  const currentLocale = getCurrentLocale();
  const $exportSubscriptionBtn = $('.exportProfilesBtn');

  if ($exportSubscriptionBtn.length === 0) { return null }

  const isV2 = $exportSubscriptionBtn.data('design-version') === 'v2';

  const $exportsSection = $('#profile_exports');

  const $newExportContainer = $('.export-entries');
  const downloadTranslation = {
    'download': {
      'fr': 'Télécharger',
      'en': 'Download',
      'es': 'Descargar',
    },
    'in_progress': {
      'fr': 'En cours de chargement',
      'en': 'Loading',
      'es': 'Cargando',
    },
    'failed': {
      'fr': 'Erreur de chargement',
      'en': 'Loading error',
      'es': 'Error de carga',
    },
  };

  const scrollToTable = () => {
    $('html, body').animate({
      scrollTop: $('.export-entries').offset().top
    }, 1000);
  }

  const addNewExportRow = (exportId, exportData) => {
    if (isV2) {
      const v2Row = `<tr id='newExportRow${exportId}'>
          <td class='text-nowrap export-date'>${$exportSubscriptionBtn.data('current-date')}</td>
          <td class='text-center export-status'>${exportData.status_badge_html}</td>
          <td class='text-center export-document'></td>
        </tr>`;
      $newExportContainer.prepend(v2Row);
      return;
    }

    const new_export_row =
      `<tr id='newExportRow${exportId}'>
        <td class='export-date'>
            ${$exportSubscriptionBtn.data('current-date')}
          </td>
          <td class='export-status'>
            ${exportData.status}
          </td>
          <td class='export-document'>
            <div class='spinner-bar'>
              ${$exportSubscriptionBtn.data('spinner-image')}
            </div>
          </td>
        </tr>`;
    $newExportContainer.prepend(new_export_row);
  }

  const displayExportsSection = () => {
    if ($exportsSection.hasClass('d-none')) { $exportsSection.removeClass('d-none') }
  }

  if ($exportSubscriptionBtn.length) {
    $exportSubscriptionBtn.on('click', () => {
      scrollToTable();
    });
  }

  App.cable.subscriptions.create(
    { channel: 'AssetManagementAdvisors::ExportProfilesChannel',
      profile_id: $exportSubscriptionBtn.data('profile-id')
     }, {
      received(data) {
        if (data.generating) {
          displayExportsSection();

          addNewExportRow(data.export_id, data);
        } else if (data.success) {
          const $newExportRowEl = $(`#newExportRow${data.export_id}`);

          $newExportRowEl.find('.export-date').html(data.created_at);
          $newExportRowEl.find('.export-type').html(data.type);

          if (isV2) {
            $newExportRowEl.find('.export-status').html(data.status_badge_html);
            $newExportRowEl.find('.export-document').html(data.download_link_html);
          } else {
            const downloadLabel = downloadTranslation['download'][currentLocale];
            $newExportRowEl.find('.export-status').html(data.status);
            $newExportRowEl.find('.export-document').html(
              `<a href='${data.export_url}' target='_blank' rel='noopener noreferrer nofollow'>${downloadLabel}</a>`
            );
          }
        } else {
          const $newExportRowEl = $(`#newExportRow${data.export_id}`);
          $newExportRowEl.find('.export-document .spinner-bar').remove();
          $newExportRowEl.find('.export-date').html(data.created_at);
          $newExportRowEl.find('.export-type').html(data.type);

          if (isV2) {
            $newExportRowEl.find('.export-status').html(data.status_badge_html);
            $newExportRowEl.find('.export-document').html('');
          } else {
            $newExportRowEl.find('.export-status').html(downloadTranslation['failed'][currentLocale]);
            $newExportRowEl.find('.export-document').html(
              `<img src='${data.failed_icon_url}' height='30' class='me-2' />`
            );
          }
        }
      }
    }
  );
});
